export default "__VITE_ASSET__e2e152b4__"